<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 11:15:13
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-17 19:39:05
-->
<template>
  <div class="judge-question">
    <el-form
      ref="judgeForm"
      :model="questionInfo"
      :rules="rules"
      label-width="70px"
      class="judgeForm"
    >
      <el-form-item label="题干:" prop="questionName">
        <tinymce
          ref="editor"
          v-model="questionInfo.questionName"
          height="170"
          width="812"
        ></tinymce>
      </el-form-item>
      <el-form-item
        v-if="questionInfo.optionList && questionInfo.optionList.length"
        label="选项:"
        prop="rightOptionId"
      >
        <el-radio
          v-for="item in questionInfo.optionList"
          :key="item.id"
          v-model="questionInfo.rightOptionId"
          :label="item.id"
          >{{ item.optionName }}</el-radio
        >
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button :loading="saveLoading" type="primary" @click="save">保存</el-button>
      <el-button @click="remove">删除</el-button>
    </div>
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce'
export default {
  name: 'JudgeQuestion',
  components: { Tinymce },
  props: {
    questionInfo: {
      type: Object,
      default: () => ({}),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagList: ['a', 'b'],
      rules: {
        questionName: [{ required: true, message: '请输入题干', trigger: 'blur' }],
        rightOptionId: [{ required: true, message: '请选择选项', trigger: 'change' }],
      },
    }
  },
  methods: {
    save() {
      const { questionName, questionType, score, optionList, rightOptionId } = this.questionInfo
      let optionObj = {}
      optionList.map((item, index) => {
        if (rightOptionId == item.id) {
          optionObj.rightKey = index + 1
        }
        this.$set(optionObj, this.tagList[index], item.optionName)
      })
      let params = {
        questionName,
        questionType,
        score,
        ...optionObj,
      }
      this.$emit('edit', params)
    },
    remove() {
      this.$emit('remove')
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-form {
  .tox-tinymce {
    width: 820px;
  }
  .el-radio-group {
    padding-top: 5px;
  }
  .el-radio {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .el-radio__label {
    box-sizing: border-box;
    display: block;
    width: 100px;
    height: 30px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d8dee6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    padding: 0;
  }
}
</style>
